// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[class^=\"menu transition\"][data-v-5e1c077e]{max-height:400%!important}.errorMessageValidation[data-v-5e1c077e]{width:100%;align-self:center;display:flex;justify-content:center}.password-field[data-v-5e1c077e]{position:relative}.help[data-v-5e1c077e]{display:flex;gap:4px}", ""]);
// Exports
module.exports = exports;
